import { render } from "./Modal-wrapper.vue?vue&type=template&id=88f369de"
import script from "./Modal-wrapper.vue?vue&type=script&lang=js"
export * from "./Modal-wrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__